import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDeviceIntelligenceNewSdkWithUser } from '../../Hooks/useDeviceIntelligenceNewSdk';

const LEGACY_LOCAL_STORAGE_KEYS = ['cookie_device_id', 'device_token'];

function useLegacyLocalStorageCleanup() {
  useEffect(() => {
    LEGACY_LOCAL_STORAGE_KEYS.forEach((key) => {
      try {
        if (window.localStorage.getItem(key) !== null) {
          window.localStorage.removeItem(key);
        }
      } catch (error) {
        // localStorage may be unavailable (private mode, disabled storage); ignore.
      }
    });
  }, []);
}

const DeviceIntelligenceCollector = ({ user }) => {
  useLegacyLocalStorageCleanup();
  useDeviceIntelligenceNewSdkWithUser(user);
  return null;
};

DeviceIntelligenceCollector.propTypes = {
  user: PropTypes.object,
};

const DeviceIntelligenceProvider = () => {
  const userState = window.__INITIAL_STATE?.user;

  const user = userState
    ? {
        id: userState.user_id,
        email: userState.email,
        fullName: `${userState.first_name || ''} ${userState.last_name || ''}`.trim(),
      }
    : null;

  return <DeviceIntelligenceCollector user={user} />;
};

export default DeviceIntelligenceProvider;
